import { Component, ElementRef, HostListener, inject, OnInit, signal, ViewChild } from "@angular/core";
import { NgIcon, provideIcons } from "@ng-icons/core";
import { heroUsers } from "@ng-icons/heroicons/outline";
import {
  bootstrapInstagram,
  bootstrapBellFill,
  bootstrapTiktok,
  bootstrapSearch,
  bootstrapBell,
  bootstrapChevronDown,
} from "@ng-icons/bootstrap-icons";
import { MenubarModule } from "primeng/menubar";
import { MainBtnComponent } from "../../../shared/UI/main-btn/main-btn.component";
import { NavigationEnd, Router, RouterLink } from "@angular/router";
import { MenuItem } from "primeng/api";
import { filter } from "rxjs";
import { AvatarModule } from "primeng/avatar";
import { AvatarGroupModule } from "primeng/avatargroup";
import { LoginService } from "../../services/login.service";
import { MenuModule } from "primeng/menu";
import { FormsModule } from "@angular/forms";
import { Menu } from "primeng/menu";
import { ButtonModule } from "primeng/button";
import { StorageService } from "../../services/storage.service";
import { User } from "../../../models/isubject-details-response";

@Component({
  selector: "app-navbar",
  imports: [
    ButtonModule,
    NgIcon,
    Menu,
    MenuModule,
    AvatarGroupModule,
    AvatarModule,
    MenubarModule,
    RouterLink,
    MainBtnComponent,
    RouterLink,
    FormsModule,
  ],
  viewProviders: [
    provideIcons({
      heroUsers,
      bootstrapInstagram,
      bootstrapBellFill,
      bootstrapSearch,
      bootstrapTiktok,
      bootstrapChevronDown,
      bootstrapBell,
    }),
  ],
  templateUrl: "./navbar.component.html",
  styleUrl: "./navbar.component.css",
})
export class NavbarComponent implements OnInit {
  items: MenuItem[] | undefined = [
    {
      label: "Our Curriculums",
      routerLink: "/curriculum",
    },
    {
      label: "Revision Notes",
      routerLink: "/revision-notes-tool",
    },
    {
      label: "Flash Cards",
      routerLink: "/flash-cards-tool",
    },
    {
      label: "Exam Questions",
      routerLink: "/exam-question-tool",
    },
    {
      label: "Past Paper",
      routerLink: "/past-paper-tool",
    },
  ];

  itemsMobile: MenuItem[] | undefined = [
    {
      label: "Revision Notes",
      routerLink: "/revision-notes-tool",
    },
    {
      label: "Flash Cards",
      routerLink: "/flash-cards-tool",
    },
    {
      label: "Exam Questions",
      routerLink: "/exam-question-tool",
    },
    {
      label: "Past Paper",
      routerLink: "/past-paper-tool",
    },
    {
      label: "Login",
      data: "auth",
      routerLink: "/student/login",
    },
    {
      label: "Signup",
      data: "auth",
      routerLink: "/student/signup",
    },
  ];
  selectedUserItem!: any;
  userItems: any[] = [
    {
      label: "My Subjects",
      router: "/home",
    },
    {
      label: "Logout",
    },
  ];
  currentRoute = signal<string>("");
  isLandingPage = signal<boolean>(false);
  isNotAuthPage = signal<boolean>(false);
  //  renderer = inject(Renderer2);

  // private _loginService = inject(LoginService);
  private router = inject(Router);
  private _storageService = inject(StorageService);
  profileData = signal<User | null>(null);
  isLoggedIn = signal<boolean>(false);

  @ViewChild("menuItem", { static: true, read: ElementRef }) menubarRef!: ElementRef<HTMLElement>;

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    if (!this.menubarRef || !this.menubarRef.nativeElement) return;
    const relatedTarget = event.relatedTarget as HTMLElement | null;
    const menuEl = this.menubarRef.nativeElement;
    if (!menuEl) return;
    if (!relatedTarget || !menuEl.contains(relatedTarget)) {
      menuEl?.classList.remove("p-menubar-mobile-active");
    }
  }

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentRoute.set(event.urlAfterRedirects);
      // console.log('Current active route:', this.currentRoute());

      const token = this._storageService.getSessionStorageValue("token");
      token ? this.isLoggedIn.set(true) : this.isLoggedIn.set(false);
      const userData = this._storageService.getSessionStorageValue("userData");
      this.profileData.set(userData);

      // console.log('token:', token, 'isLoggedIn:', this.isLoggedIn());
      if (this.currentRoute() === "/student/login" || this.currentRoute() === "/student/signup") {
        this.isNotAuthPage.set(true);
        this.isLandingPage.set(false);
        // console.log('Current active route:', this.currentRoute());
        // console.log('isLandingPage:', this.isLandingPage());
      } else {
        if (this.currentRoute() === "/") {
          this.isLandingPage.set(true);
          this.isNotAuthPage.set(false);
          // console.log('Current active route:', this.currentRoute());
          // console.log('isLandingPage:', this.isLandingPage());
        } else {
          this.isLandingPage.set(false);
          this.isNotAuthPage.set(false);
          //   console.log('Current active route:', this.currentRoute());
          // console.log('isLandingPage:', this.isLandingPage());
        }
      }
    });
  }

  logout() {
    console.log("logout");
    this._storageService.clearLocalStorage();
    this._storageService.clearSessionStorage();
    this.router.navigate(["/student/login"]);
  }

  onMenubarButtonClick(event: MouseEvent) {
    event.stopPropagation();
    if (!this.menubarRef?.nativeElement) return;
    if (this.menubarRef?.nativeElement) {
      this.menubarRef?.nativeElement?.classList.add("p-menubar-mobile-active");
    }
  }

  @ViewChild("menu") menu!: Menu;

  onMenuToggleClick(event: MouseEvent) {
    // event.stopPropagation();
    this.menu.toggle(event);
  }
}
